import { gql } from '@apollo/client';

/**
 * updateTmsTaskBolInfo 的类型化补丁输入：只更新实际传入的字段。
 * 属性不传 = 不更新；显式传 null = 清空该列。
 */
export interface BolInfoUpdateInput {
    shipFromAddress?: string | null;
    shipFromCityStateZipcode?: string | null;
    shipFromContactName?: string | null;
    shipFromContactPhoneNumber?: string | null;
    shipToAddress?: string | null;
    shipToCityStateZipcode?: string | null;
    shipToContactName?: string | null;
    shipToContactPhoneNumber?: string | null;
    trailerNumber?: string | null;
    truckNumber?: string | null;
    licensePlate?: string | null;
    driverName?: string | null;
    driverPhone?: string | null;
    proNumber?: string | null;
    sealNumber?: string | null;
}

export const UPDATE_TMS_TASK_BOL_INFO = gql`
  mutation UpdateTmsTaskBolInfo(
    $taskId: Long!
    $segment: Int
    $input: UpdateTmsTaskBolInfoInput!
  ) {
    updateTmsTaskBolInfo(taskId: $taskId, segment: $segment, input: $input) {
      id
      taskId
      segment
    }
  }
`;
